import * as React from 'react';
import { Grid } from '@material-ui/core';
import { Edit, SimpleForm, TextInput, SelectInput, required } from 'react-admin';
import { useServerValidation } from '../../helpers';
import { COUNTRIES, PROVIDER_STATUSES } from '../../constants';

export default (props) => {
  const { onFailure } = useServerValidation();
  return (
    <Grid item lg={6} md={8} xs={12}>
      <Edit {...props} onFailure={onFailure} undoable={false}>
        <SimpleForm>
          <TextInput disabled source="id" fullWidth />
          <SelectInput source="status" choices={PROVIDER_STATUSES} fullWidth />
          <TextInput source="email" fullWidth validate={required()} />
          <TextInput source="first_name" fullWidth validate={required()} />
          <TextInput source="last_name" fullWidth validate={required()} />
          <TextInput source="brand" fullWidth validate={required()} />
          <TextInput source="phone" fullWidth validate={required()} />
          <TextInput source="address" fullWidth validate={required()} />
          <TextInput source="secondary_email" fullWidth />
          <TextInput source="company" fullWidth />
          <SelectInput source="country" choices={COUNTRIES} fullWidth />
        </SimpleForm>
      </Edit>
    </Grid>
  );
};
